module.exports = fox._r("fonts/throughChat.ttf?exnqbq", __webpack_public_path__ + "_/_/_/root/fonts/saGLfpa.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/throughChat.ttf?exnqbq
// module id = 449
// module chunks = 4